import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { AcceptInviteSuccess, RejectInviteSuccess } from '../action-creators';
import { ACCEPT_INVITE_SUCCESS, REJECT_INVITE_SUCCESS } from '../actions';
import { ListNotifications } from '@webapp/store/notifications/action-creators';

export const actionsInviteEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, AcceptInviteSuccess | RejectInviteSuccess>(
      ACCEPT_INVITE_SUCCESS,
      REJECT_INVITE_SUCCESS
    ),
    mergeMap(async () => {
      return new ListNotifications();
    })
  );
